import React from 'react';

import { useEventState } from '@atlas/core/build';
import { Icon } from '@atlas/ui';

import { sportService } from 'common/constants';
import useIsPrematch from 'components/Sportsbook/useIsPrematch';

const { LIVE, PREMATCH } = sportService;

const EventStatistics = ({ swipe }) => {
  const event = useEventState();
  const { externalId, sportService } = event;
  const isPrematch = useIsPrematch();

  return (
    <div className="tournament-scroll-event-statistic">
      {sportService === LIVE && externalId && (
        <Icon
          className="small icon-container icon-live-statis"
          name={swipe ? 'statistics' : 'live-statis'}
        />
      )}

      {sportService === PREMATCH && externalId && (
        <Icon
          className="small icon-container icon-statistic"
          name={swipe ? 'statistics' : 'live-statis'}
        />
      )}

      {externalId && !isPrematch && (
        <Icon className="small icon-container icon-video" name={swipe ? 'live-stream' : 'video'} />
      )}
    </div>
  );
};
export default EventStatistics;
